// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2yxg7","box":"WorkspacesBox_box__PRzyM","node":"WorkspacesBox_node__1V9CF"};